export enum franchiseTabs {
  upgrades = 'Upgrades',
  memberships = 'Memberships',
  packages = 'Packages',
}
